type NamedData = {
  first_name: string
  last_name: string
}

export const getFullName = ({ first_name, last_name }: NamedData) => {
  return `${first_name} ${last_name}`
}
